import { render, staticRenderFns } from "./TableElement.vue?vue&type=template&id=24c1dc0f&scoped=true"
import script from "./TableElement.vue?vue&type=script&lang=js"
export * from "./TableElement.vue?vue&type=script&lang=js"
import style0 from "./TableElement.vue?vue&type=style&index=0&id=24c1dc0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c1dc0f",
  null
  
)

export default component.exports